<template>
  <div class="gif-container">
    <img
      ref="gif"
      class="rounded-top-9"
      :src="href"
      alt="GIF" 
      crossorigin="anonymous" referrerpolicy="no-referrer"/>
    <div class="overlay"></div>
    <span class="px-2 rounded text-white font-10 text-gif">GIF</span>
    <img
      @click="playPause"
      class="icon-gif pointer"
      src="/assets/icon/v2-gif.svg" />
  </div>
</template>

<script>

export default {
  props: ["href"],
  data() {
    return {
      src: null,
      info: {
        name: "",
        image: "",
      },
      errors: [],
    };
  },
  methods: {
    playPause() {
    },
  },

  created() {},
};
</script>

<style lang="scss">
.paused img {
  animation-play-state: paused !important;
}
.gif-container {
  position: relative;
  display: inline-block;
}
.gif-container:hover {
  .icon-gif {
    opacity: 1;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 9px 9px 0 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gif-container:hover .overlay {
  opacity: 1;
}

.text-gif {
  position: absolute;
  top: 0.375rem;
  left: 0.5rem;
  background: rgba(122, 127, 131, 0.6);
}
.icon-gif {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
</style>
